/**
 * Some chat config widely used in selenium.
 * Opens when `seleniumConfig` flag is set.
 */
const chatConfig = {
  config: {
    name: "Test Facility",
    apiChatStartURL: "getUUIDurl",
    introText: "Hi! Nice to meet you.",
    teaser: "Hey there, is there something I can help you find?",
    createURL: "testLeadCreateUrl",
    maxPhoneAttempts: 3,
    images: [
      "https://www.seniorlivingresidences.com/assets/Uploads/_resampled/ScaleWidthWyIxMjgwIl0/Assisted-Living-Brookline-Goddard-House.jpg",
      "https://familyassets.s3.amazonaws.com:443/uploaded_facility/342acd36749ba316fb9b75f4d6bec56a.jpeg",
      "https://familyassets.s3.amazonaws.com:443/uploaded_facility/127a691eede07784dcddc0ce01b955bc.jpeg",
      "https://familyassets.s3.amazonaws.com:443/uploaded_facility/6a37d6f926c6335ac2ce4155253edb40.jpeg",
      "https://familyassets.s3.amazonaws.com:443/uploaded_facility/90a62264cdc1d83fa17276972b2376b9.jpeg",
    ],
    videos: ["https://www.youtube.com/watch?v=gtmzPUmq7XU"],
    digital_tours: [
      '<iframe src="https://cdn.bitdegree.org/learn/test-iframe.htm" width="90%" height="300px"></iframe>',
    ],
    startingCost: 4300,
    prices: [
      {
        cost: 4031,
        name: "Assisted Living",
      },
      {
        cost: 5399,
        name: "Memory Care",
      },
    ],
    floorplans: [
      {
        id: 2,
        name: "Blue Topaz",
        care_types: ["One bedroom"],
        room_size: "Studio",
        care_description: null,
        sq_feet: 165,
        image:
          "https://www.pegasusseniorliving.com/tucson-place-at-ventana-canyon/wp-content/uploads/sites/34/2019/09/Tucson-Place-Web-Blue-Topaz.png",
        num_baths: 1,
      },
      {
        id: 3,
        name: "Crystal",
        care_types: ["One bedroom"],
        room_size: "Studio",
        care_description: null,
        sq_feet: 165,
        image:
          "https://www.pegasusseniorliving.com/tucson-place-at-ventana-canyon/wp-content/uploads/sites/34/2019/09/Tucson-Place-Web-Crystal.png",
        num_baths: 1,
      },
      {
        id: 4,
        name: "Diamond",
        care_types: ["One bedroom"],
        room_size: "Studio",
        care_description: null,
        sq_feet: 165,
        image:
          "https://www.pegasusseniorliving.com/tucson-place-at-ventana-canyon/wp-content/uploads/sites/34/2019/09/Tucson-Place-Web-Diamond.png",
        num_baths: 1,
      },
    ],
  },
  modules: {
    "1": {
      action: null,
      answers: [
        {
          action: 2,
          text: "Pricing",
        },
      ],
      key: "what",
      text: "What would you like assistance with?",
      type: "option",
    },
    "2": {
      action: null,
      answers: [
        {
          action: 3,
          text: "Assisted Living",
        },
        {
          action: 3,
          text: "Respite Care",
        },
        {
          action: 3,
          text: "Memory Care",
        },
        {
          action: 3,
          text: "Retirement Living",
        },
      ],
      key: "care",
      text: "Which of the following services are you are interested in?",
      type: "option",
    },
    "3": {
      action: null,
      answers: [
        {
          action: 4,
          text: "Parent",
        },
        {
          action: 4,
          text: "Spouse",
        },
        {
          action: 4,
          text: "Myself",
        },
        {
          action: 4,
          text: "Relative",
        },
      ],
      key: "who",
      text: "Who is this for?",
      type: "option",
    },
    "4": {
      action: null,
      answers: [
        {
          action: 5,
          text: "Immediately",
        },
        {
          action: 5,
          text: "1 to 3 Months",
        },
        {
          action: 5,
          text: "3 Months +",
        },
        {
          action: 5,
          text: "Just Researching",
        },
      ],
      key: "when",
      text: "What is your timeline?",
      type: "option",
    },
    "5": {
      action: 6,
      key: "first_name",
      text: "What is your name?",
      type: "text",
    },
    "6": {
      action: 7,
      key: "phone",
      text: "What is your cell phone number?",
      type: "phone",
    },
    "7": {
      action: 8,
      key: "email",
      text: "What is your email? We will use this to indentify your quote in our systems",
      type: "email",
    },
    "8": {
      action: 10,
      key: "tour_date",
      text: "When would you like to visit?",
      type: "date_picker",
    },
    // Not submitting the lead in Selenium tests.
    // "9": {
    //   action: 10,
    //   key: null,
    //   text: "",
    //   type: "submit",
    // },
    "10": {
      action: null,
      answers: [
        {
          action: null,
          text: "Close Bot",
        },
        {
          action: 1,
          text: "Go Back To Start",
        },
      ],
      key: "more",
      role: "pricing",
      text:
        "The price of our community starts at $3,000. Please schedule a visit to learn more about Testing Community.",
      type: "option",
    },
    "60": {
      text: null,
      action: null,
      type: "option",
      key: null,
      pk: 31772,
      answers: [
        {
          text: "Pricing",
          action: 2,
          id: 69807,
        },
        {
          text: "Iframe",
          action: 63,
          id: 69810,
        },
        {
          text: "Youtube",
          action: 62,
          id: 69811,
        },
        {
          text: "Floorplans",
          action: 61,
          id: 69812,
        },
      ],
      role: "gallery",
    },
    "61": {
      text: null,
      action: null,
      type: "option",
      key: null,
      pk: 34891,
      answers: [
        {
          text: "Gallery",
          action: 60,
          id: 78604,
        },
      ],
      role: "floorplan",
    },
    "62": {
      text: null,
      action: null,
      type: "option",
      key: null,
      pk: 34892,
      answers: [
        {
          text: "Gallery",
          action: 60,
          id: 78602,
        },
      ],
      role: "videos",
    },
    "63": {
      text: null,
      action: null,
      type: "option",
      key: null,
      pk: 34893,
      answers: [
        {
          text: "Gallery",
          action: 60,
          id: 78605,
        },
      ],
      role: "digital_tours",
    },
    "64": {
      action: 1,
      key: "tour_date",
      text: "When would you like to visit?",
      type: "date_picker",
    },
    "65": {
      text: "Please wait while we connect you with a live operator",
      action: 12,
      type: "slack",
      key: null,
      pk: 40486,
      answers: [
        {
          text: "Talk To Live Operator",
          action: 63,
          id: 90989,
        },
      ],
    },
    "66": {
      type: "financial_results",
      action: 2,
    },
  },
};

export default chatConfig;
